import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b31e928")

_pushScopeId("data-v-5b31e928")
const _hoisted_1 = { class: "main-nav" }
const _hoisted_2 = { class: "nav-header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", null, "어신 백오피스", -1)
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"admin-menu\" data-v-5b31e928><ul class=\"menu-list\" data-v-5b31e928><li data-v-5b31e928><span data-v-5b31e928><i class=\"fas fa-building fa-xl\" data-v-5b31e928></i></span> 어신 관리 </li><li data-v-5b31e928><span data-v-5b31e928><i class=\"fas fa-database fa-xl\" data-v-5b31e928></i></span> 파트너스 관리 </li><li data-v-5b31e928><span data-v-5b31e928><i class=\"fa-brands fa-product-hunt fa-xl\" data-v-5b31e928></i></span> 커머스 관리 </li><li data-v-5b31e928><span data-v-5b31e928><i class=\"fa-solid fa-cart-shopping fa-xl\" data-v-5b31e928></i></span> 공통 관리 </li></ul></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "admin-nav-link"
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _hoisted_4
  ]))
})